import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import cn from 'classnames'
import { useQuery } from '@apollo/client'
import { QUERY } from '../../apollo'
import * as Icon from '../Icons'

import styles from './layout.module.css'

function Navigation() {
  const { data } = useQuery(QUERY.USER_INFO)
  const userInfo = data?.userInfo
  const [actionsOpen, setActionsOpen] = useState(false)
  return (
    <div className={styles.navInnerWrapper}>
      <nav className={styles.nav}>
        <h2 className={styles.navHeading}>Quote</h2>
        {userInfo && (
          <ItemsList
            kind="quote"
            items={userInfo.quote}
            linkText={({ projectName, date }) => (
              <>
                {projectName}
                <br />
                <small>{date}</small>
              </>
            )}
          />
        )}

        <h2 className={styles.navHeading}>Supervision</h2>
        {userInfo && (
          <ItemsList
            kind="supervision"
            items={userInfo.supervision}
            linkText={({ licenseUser, media, date }) => (
              <>
                {licenseUser}
                <br />
                <small>
                  {media} {date}
                </small>
              </>
            )}
          />
        )}

        <h2 className={styles.navHeading}>Purchased</h2>
        {userInfo && (
          <ItemsList
            kind="purchased"
            items={userInfo.purchased}
            linkText={({ trackName, trackArtist }) => (
              <>
                {trackName}
                <br />
                <small>{trackArtist}</small>
              </>
            )}
          />
        )}
      </nav>
      <div
        className={cn(styles.actionsNavigation, styles.actionsNavigationMobile)}
      >
        <h2
          className={cn(styles.navHeading, styles.navHeadingActions)}
          // onClick={() => setActionsOpen((open) => !open)}
        >
          Actions
        </h2>
        <ul className={cn(styles.navItems, styles.actionsItems)}>
          <li>
            <NavLink
              exact
              to={`/profile`}
              className={cn(
                styles.navLink,
                styles.actionNavLink,
                styles.navLinkToHome
              )}
              activeClassName={styles.navLinkActive}
            >
              Profile Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to={`/profile/ask-supervision`}
              className={cn(styles.navLink, styles.actionNavLink)}
              activeClassName={styles.navLinkActive}
            >
              Ask for a music supervision
            </NavLink>
          </li>
          <li>
            <NavLink
              to={`/profile/contact`}
              className={cn(styles.navLink, styles.actionNavLink)}
              activeClassName={styles.navLinkActive}
            >
              Contact Us
            </NavLink>
          </li>
          <li>
            <NavLink
              to={`/profile/billing-information`}
              className={cn(styles.navLink, styles.actionNavLink)}
              activeClassName={styles.navLinkActive}
            >
              Edit Billing Information
            </NavLink>
          </li>
        </ul>
      </div>
      <div
        className={cn(
          styles.actionsNavigation,
          styles.actionsNavigationDesktop
        )}
      >
        <h2
          className={cn(styles.navHeading, styles.navHeadingActions)}
          onClick={() => setActionsOpen((open) => !open)}
        >
          Actions
          <Icon.Expand className={styles.expandIcon} />
        </h2>
        <AnimatePresence>
          {actionsOpen && (
            <motion.div
              animate={{
                opacity: 1,
              }}
              initial={{
                opacity: 0,
              }}
              exit={{
                opacity: 0,
              }}
            >
              <ul className={cn(styles.navItems, styles.actionsItems)}>
                <li>
                  <NavLink
                    exact
                    to={`/profile`}
                    className={cn(
                      styles.navLink,
                      styles.actionNavLink,
                      styles.navLinkToHome
                    )}
                    activeClassName={styles.navLinkActive}
                  >
                    Profile Home
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={`/profile/ask-supervision`}
                    className={cn(styles.navLink, styles.actionNavLink)}
                    activeClassName={styles.navLinkActive}
                  >
                    Ask for a music supervision
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={`/profile/contact`}
                    className={cn(styles.navLink, styles.actionNavLink)}
                    activeClassName={styles.navLinkActive}
                  >
                    Contact Us
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={`/profile/billing-information`}
                    className={cn(styles.navLink, styles.actionNavLink)}
                    activeClassName={styles.navLinkActive}
                  >
                    Edit Billing Information
                  </NavLink>
                </li>
              </ul>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  )
}

export default Navigation

export function ItemsList({ items, kind, linkText }) {
  const hasItems = getFirstIdIfExists(items)
  return (
    <ul className={styles.navItems}>
      {hasItems ? (
        items.map((item) => (
          <li key={item.id}>
            <NavLink
              to={`/profile/${kind}/${item.id}`}
              className={styles.navLink}
              activeClassName={styles.navLinkActive}
            >
              {linkText(item)}
            </NavLink>
          </li>
        ))
      ) : (
        <li>
          <span className={styles.navEmptyItem}>No {kind} items yet</span>
        </li>
      )}
    </ul>
  )
}

function getFirstIdIfExists(arr) {
  return arr && arr.length > 0 ? arr[0].id : null
}
